import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <Card className="bg-[#1a1a1a] border-gray-800 max-w-md w-full mx-4">
        <CardContent className="pt-6 text-center space-y-4">
          <div className="flex justify-center">
            <div className="w-16 h-16 bg-yellow-600/20 rounded-full flex items-center justify-center">
              <XCircle className="w-10 h-10 text-yellow-500" />
            </div>
          </div>
          
          <h1 className="text-2xl font-bold">Pagamento Cancelado</h1>
          <p className="text-gray-400">
            Você cancelou o pagamento. Nenhuma cobrança foi realizada.
          </p>
          
          <div className="pt-4 space-y-3">
            <Button
              className="bg-red-600 hover:bg-red-700 w-full"
              onClick={() => navigate(-1)}
            >
              Tentar Novamente
            </Button>
            <Button
              variant="outline"
              className="border-gray-700 hover:bg-gray-800 w-full"
              onClick={() => navigate("/login")}
            >
              Voltar ao Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
